import { render, staticRenderFns } from "./SupervisorDashboard5.vue?vue&type=template&id=c4a1add4&scoped=true&"
import script from "./SupervisorDashboard5.vue?vue&type=script&lang=js&"
export * from "./SupervisorDashboard5.vue?vue&type=script&lang=js&"
import style0 from "./SupervisorDashboard5.vue?vue&type=style&index=0&id=c4a1add4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4a1add4",
  null
  
)

export default component.exports